import React, { useState } from 'react';
import PropTypes from 'prop-types';
import reactifyWC from 'reactify-wc';
import { useAuthUser } from '@nbx/frontend-helpers/subscribe';
import { NBXStorage } from '@nbx/frontend-helpers/storage';
import { Trans, useTranslation } from 'react-i18next';

const NBXModalContainer = reactifyWC('nbx-modal-container');

export const TermsOfServiceModal = ({ onClose }) => {
  const { t } = useTranslation();
  const user = useAuthUser();
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  const handleSubmit = () => {
    if (!acceptedTerms) return;
    NBXStorage.setItem(`TOS-ACCEPTED-${user.email}`, true, { useLocalStorage: true }).then(onClose);
  };

  // NOTE: we don't allow the user to close this modal without agreeing
  // so we purposefully don't listen for requestClose or clicks on the overlay
  return (
    <NBXModalContainer open onRequestSubmit={handleSubmit}>
      <nbx-modal-overlay slot="overlay" />
      <nbx-modal-alert slot="modal" heading={t('tos_modal_review_n_accept')}>
        <nbx-checkbox checked={acceptedTerms} onClick={() => setAcceptedTerms(!acceptedTerms)}>
          <nbx-text muted={!acceptedTerms} slot="label">
            <Trans i18nKey="tos_modal_i_accept">
              <nbx-button-text
                muted={!acceptedTerms}
                underlined
                href="https://nbx.com/en/terms-of-service"
                onClick={e => e.stopPropagation()}
              />
            </Trans>
          </nbx-text>
        </nbx-checkbox>
        <nbx-button slot="center-button" onClick={handleSubmit} disabled={!acceptedTerms}>
          {t('common_continue')}
        </nbx-button>
      </nbx-modal-alert>
    </NBXModalContainer>
  );
};

TermsOfServiceModal.propTypes = {
  onClose: PropTypes.func.isRequired
};
